import { render } from "./ActionButtonsInput.vue?vue&type=template&id=f2a61516&ts=true"
import script from "./ActionButtonsInput.vue?vue&type=script&lang=ts"
export * from "./ActionButtonsInput.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__